import { render, staticRenderFns } from "./ConfigCompany.vue?vue&type=template&id=77b53503&scoped=true&"
import script from "./ConfigCompany.vue?vue&type=script&lang=js&"
export * from "./ConfigCompany.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCompany.vue?vue&type=style&index=0&id=77b53503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b53503",
  null
  
)

export default component.exports